import "./Footer.css";
import awardIcon from "../../assets/Antonio-Meucci.jpg";
import awardIcon2 from "../../assets/mvno-nation.jpg";
import logoGb from "../../assets/logo-gb.png";

export default function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__inner">
        {/* 1) Logo + nazwa */}
        <section className="footer__col footer__brand">
          <img className="footer__logo" src={logoGb} alt="Globtel GmbH" />
          <h3 className="footer__title">Globtel GmbH</h3>
          <p className="footer__tagline">
            Your Partner in Global Telecommunication
          </p>
        </section>

        {/* 2) Adresy */}
        <section className="footer__col footer__offices" aria-label="Offices">
          <h3 className="section__title">Get in touch</h3>
          <div className="offices__grid">
            <div className="office">
              <h5 className="office__title">Office in Berlin</h5>
              <p className="office__phone">+49 30 22957331</p>
              <p className="office__addr">
                Westhafenstr. 1 13353 Berlin, Germany
              </p>
            </div>
            <div className="office">
              <h5 className="office__title">Office in Warsaw</h5>
              <p className="office__phone">+48 22 213 39 00</p>
              <p className="office__addr">
                ul. Skierniewicka 16/20 01-230 Warszawa, Polska
              </p>
            </div>
          </div>
        </section>
        {/* 3) Nagrody – lista pionowa: ikona + link + data */}
        <section className="footer__col footer__awards" aria-label="Awards">
          <h3 className="section__title">Latest news</h3>
          <article className="award-item">
            <img
              className="award__icon"
              src={awardIcon}
              alt=""
              aria-hidden="true"
            />
            <div className="award__body">
              <a
                className="award__link"
                href="https://globtel.de/uncategorized/success-on-antonio-meucci-awards-2024/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Success on Antonio Meucci Awards 2024
              </a>
              <time className="award__date" dateTime="2024-10-07">
                October 7, 2024
              </time>
            </div>
          </article>
          <article className="award-item">
            <img
              className="award__icon"
              src={awardIcon2}
              alt=""
              aria-hidden="true"
            />
            <div className="award__body">
              <a
                className="award__link"
                href="https://globtel.de/uncategorized/mvno-nation-event-in-valencia/"
                target="_blank"
                rel="noopener noreferrer"
              >
                MVNO Nation Event in Valencia
              </a>
              <time className="award__date" dateTime="2023-06-23">
                June 23, 2023
              </time>
            </div>
          </article>
        </section>
      </div>

      <div className="footer__bar">
        <small>
          © {new Date().getFullYear()} Globtel GmbH. All rights reserved.
        </small>
      </div>
    </footer>
  );
}
